<script>
  import { XIcon, Edit3Icon, CheckIcon } from 'vue-feather-icons'

  export default {
    components: { XIcon, Edit3Icon, CheckIcon },
    props: {
      group: {
        type: [String, Number],
        default: '',
      },
      fieldName: {
        type: [String, Number],
        default: '',
      },
      fieldContent: {
        type: [String, Number],
        default: '',
      },
      edit: {
        type: Boolean,
        default: false,
      },
      toggleEditFunction: {
        type: Function,
        required: true,
      },
      isTailwind: {
        type: Boolean,
        default: false,
      },
      valuePrefix: {
        type: String,
        default: '',
      },
      isError:{
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        name: this.fieldName,
        content: this.fieldContent,
      }
    },
    computed:{
      isValid(){
        if (!this.name || (this.name && (typeof(this.name) === 'string' && this.name.length === 0))){
          return false
        }
        if (!this.content || (this.content && (typeof(this.content) === 'string' && this.content.length === 0))){
          return false
        }
        return true
      }
    },
    methods: {
      tryToEdit () {
        this.$emit('editClick', this.group, this.fieldName, this.name, this.content)
      },
      tryToDelete () {
        this.$emit('deleteClick', this.group, this.fieldName)
      },
    },
  }
</script>

<template>
  <div
    v-if="isTailwind"
    class="edit-form-item tw-mt-2 tw-pr-[5.75rem]"
    :class="{ 'tw-border-red-500': isError }">
    <div
      class="
      item-info
      tw-flex tw-justify-between sm:tw-justify-start
      tw-gap-x-5 sm:tw-gap-x-32
      tw-px-2.5 tw-py-2
      tw-w-full">
      <article class="tw-truncate">
        <p v-if="!edit" class="tx-label mg-b-0 tw-h-7 tw-leading-7 tw-capitalize tw-truncate">{{ fieldName }}:</p>
        <input
          v-else
          v-model="name"
          type="text"
          class="form-control !tw-py-u !tw-h-7"
          placeholder="Key" />
      </article>
      <article>
        <p v-if="!edit" class="tw-text-right tx-value mg-b-0 text-bold tw-h-7 tw-leading-7">{{ `${valuePrefix}${fieldContent}` }}</p>
        <input
          v-else
          v-model="content"
          type="text"
          class="tw-text-right sm:tw-text-left form-control !tw-py-u !tw-h-7"
          placeholder="Value" />
      </article>
    </div>
    <div class="action-group mg-l-auto tw-flex-shrink-1">
      <button
        v-if="!edit"
        v-bind="$attrs"
        type="button"
        class="btn btn-icon button-action button-action-positive btn-highlight"
        @click="toggleEditFunction">
        <Edit3Icon size="1x" />
      </button>
      <button
        v-else
        v-bind="$attrs"
        :disabled="!isValid"
        type="button"
        class="btn btn-icon button-action button-action-active btn-highlight"
        @click="tryToEdit">
        <CheckIcon size="1x" />
      </button>
      <button
        v-bind="$attrs"
        type="button"
        class="btn btn-icon button-action button-action-negative btn-highlight"
        @click="tryToDelete">
        <XIcon size="1x" />
      </button>
    </div>
  </div>
  <div v-else class="edit-form-item tw-mt-2">
    <div class="item-info">
      <div class="col-md-2 left-ct">
        <p v-if="!edit" class="tx-label mg-b-0">{{ fieldName }}</p>
        <input
          v-else
          v-model="name"
          type="text"
          class="form-control !tw-rounded-md !tw-h-7"
          placeholder="Key" />
      </div>
      <div class="col-md-10 right-ct">
        <p v-if="!edit" class="tx-value mg-b-0 text-bold !tw-h-7">{{ fieldContent }}</p>
        <input
          v-else
          v-model="content"
          type="text"
          class="form-control !tw-rounded-md !tw-h-7"
          placeholder="Value" />
      </div>
    </div>
    <div class="action-group mg-l-auto tw-flex-shrink-1">
      <button
        v-if="!edit"
        v-bind="$attrs"
        type="button"
        class="btn btn-icon button-action button-action-positive btn-highlight"
        @click="toggleEditFunction">
        <Edit3Icon size="1x" />
      </button>
      <button
        v-else
        v-bind="$attrs"
        :disabled="!isValid"
        type="button"
        class="btn btn-icon button-action button-action-active btn-highlight"
        @click="tryToEdit">
        <CheckIcon size="1x" />
      </button>
      <button
        v-bind="$attrs"
        type="button"
        class="btn btn-icon button-action button-action-negative btn-highlight"
        @click="tryToDelete">
        <XIcon size="1x" />
      </button>
    </div>
  </div>
</template>
